import openPartnerDialog from './openPartnerDialog';
import initOffset from '../common/initOffset';

export default function initPartnerForm() {
  initOffset(openPartnerDialog, '.js-partners__links-click-open-modal');
}
